import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.onScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  handleScroll() {
    this.element.classList.toggle("scrolled", window.scrollY > 20)
  }

  toggleMenu() {
    this.menuTarget.classList.toggle("hidden")
  }
}
